const styles = (theme) => ({
  subheading: {
    fontSize: '1.125rem',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  label: {
    fontWeight: 500,
  },
  changes: {
    textAlign: 'left',
  },
  dialogText: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  field: {
    marginBottom: theme.spacing.unit,
  },
});

export default styles;
